import { Component, EventEmitter, Output } from '@angular/core';
import { Session } from '../../../core/business-objects/session/session.model';
import { BaseComponent } from '../../../core/components/base.component';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';

@Component({
    selector: 'vas-side-menu',
    templateUrl: 'side-menu.component.html'
})
export class SideMenuComponent extends BaseComponent {
    @Output() page = new EventEmitter<string>();

    session: Session;

    constructor(protected appFacade: VasAppFacade) {
        super();
    }

    ngOnInit(): void {

        this.appFacade.session.getSession()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(session => this.session = session);
    }

    get isAuthenticated(): boolean {
        return this.session ? this.session.getNetworkStatus().isAuthenticated() : false;
    }

    onHome(): void {
        this.page.next('AccountsPage');
    }

    onSignIn(): void {
        this.page.next('LoginPage');
    }

    onSignOut(): void {
        this.appFacade.auth.logout();
        this.page.next('LoginPage');
    }

    onSettings(): void {
        this.page.next('SettingsPage');
    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/side-menu/side-menu.component.ts